/**
 * 需要想定値の数値入力欄における IME 入力段階フィルタ (design note
 * demand-disable-ime Decision 1、AC-DFC-EDIT-003 の小数入力を妨げない)。
 *
 * IME 由来の「化け」文字 (全角数字・かな・漢字・英字・非許容記号) を除去し、
 * 半角 ASCII 数字と `.` `-` `,` のみを通す。KomaGrid セル編集 input・
 * RescaleModal 目標最大電力 input の両方が本関数を共有する
 * (composition/onChange 経路で呼ぶ、実 IME 変換自体の無効化ではない)。
 *
 * 小数点・負号は通す: `.` を入力段階で弾くと「100.5」が黙って「1005」に
 * なる silent な値変化を生むため。小数は拒否せず
 * そのまま保持する (AC-DFC-EDIT-003)。
 */
export function filterNumericImeInput(value: string): string {
  return value.replace(/[^0-9.,-]/g, '')
}
